module.exports = __webpack_public_path__ + "img/progressOrder.f1cda396.svg";